module.exports = __webpack_public_path__ + "static/media/21.ee18fd6a.png";